<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des clients</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddClient')">
        <router-link class="btn btn-primary" to="/clients/ajouter-client">
          <i class="fa fa-plus-circle"></i>
          Ajouter un client
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher" class="form-control shadow-none text-black"
            placeholder="Rechercher un client" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Numéro Client
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nom et prénom
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Téléphone
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="client in clients" :key="client.id">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ client.numeroClient }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ client.nomClient }} {{ client.prenomClient }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ client.telephone1 }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">Actions</button>
                <ul class="dropdown-menu dropdown-block">
                  <li class="dropdown-item d-flex align-items-center" v-if="checkPermission('EditClient')">
                    <router-link :to="{ name: 'EditClient', params: { id: client.id } }"
                      class="dropdown-item d-flex align-items-center">
                      <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier
                    </router-link>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Client } from "@/models/Client";
import ApiService from "@/services/ApiService";
import { error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";

export default defineComponent({
  name: "ListeClient",
  components: { PaginationComponent },
  setup() {
    const clients = ref<Array<Client>>([]);

    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const getAllClient = (pageCourante = 1, limite = 10, mot = '') => {
      return ApiService.get(`/clients?page=${pageCourante}&limit=${limite}&mot=${encodeURIComponent(mot)}`)
        .then(({ data }) => {
          clients.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch((err) => {
          error(err?.response?.data?.message ?? "La liste des clients n'a pas pu être récupérée.");
        });
    };

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      page.value = page_;
      getAllClient(page_, limit_, searchTerm.value);
    };

    const rechercher = () => {
      page.value = 1;   // on repart de la première page à chaque recherche
      getAllClient(1, limit.value, searchTerm.value);
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name: string) => privileges.value.includes(name);

    onMounted(() => {
      getAllClient();
    });

    return {
      clients, checkPermission, page, totalPages, limit, totalElements,
      handlePaginate, rechercher, searchTerm,
    };
  },
});
</script>